import React from 'react';
import TireSelectBottomSheet from '@di-shared/features/diag/tire/TireSelectBottomSheet';

interface TireSelectionBottomSheetPageProps {
  vin: string;
}

function TireSelectionBottomSheetPage({vin}: TireSelectionBottomSheetPageProps) {
  return <TireSelectBottomSheet vin={vin} />;
}

export default TireSelectionBottomSheetPage;
